/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase, rowSpacing, enterpriseCSS, paletteHD,
} from './variables';

import { StatusTrackingBar } from './common/StatusTrackingBar';

export const OrderDetailsStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        OrderDetailsStyle: {
            '& .orderDetailsContainer': {
                margin: '0 auto',
                width: '326px',
                textAlign: 'center',
                '& h1': {
                    fontSize: '20px',
                    letterSpacing: '0.5px',
                    fontWeight: 700,
                },
                '@media screen and (max-width: 1024px)': {
                    width: 'auto',
                    marginTop: '30px',
                    '& h1': {
                        fontSize: '16px',
                        fontWeight: 700,
                        letterSpacing: '0.4px',
                    },
                },
            },
            '& .orderItemsContainer': {
                '&>div:last-child': {
                    '&>div:last-child': {
                        '&>div:last-child': {
                            '&>div:last-child': {
                                border: 'none',
                            },
                            '&>hr:last-child': {
                                display: 'none',
                            },
                        },
                    },
                },
            },
            // desktop Order Detail
            '& .desktop-view': {
                maxWidth: '1440px',
                width: '100%',
                margin: 'auto',

                '& .order-detail-guest': {
                    margin: '0 auto',
                },

                '& .delivery-info': {
                    borderRadius: '0px',
                },
                '& .width': {
                    width: '100%',
                },
                '& .padding-zero': {
                    padding: '0px',
                },
                '& .padding-10': {
                    padding: '10px',
                },
                '& .dekstop-order-details-title': {
                    marginBottom: rowSpacing * 2,
                },
                '& .top-button-wrapper': {
                    marginBottom: rowSpacing * 2,
                    textAlign: 'right',
                },
                '& .desktop-item-detail': {
                    padding: '0px',
                    '& .desktop-status-bar': {
                        padding: rowSpacing * 2,
                        '& .statusTrackingBar': {
                            margin: '0px !important',
                        },
                        '& .link': {
                            cursor: 'pointer',
                        },
                    },
                    '& .bottom-border': {
                        borderBottom: `1px solid ${enterpriseCSS.palette.gray3}`,
                    },
                    '& .desktop-shipping': {
                        padding: rowSpacing * 2,
                        '& .desktop-modify-error': {
                            marginTop: '70px',
                        },
                        '& .min-height-100': {
                            minHeight: '100px',
                        },
                        '& .border-radius-zero': {
                            borderRadius: '0px',
                        },
                        '& .margin-top-bottom-10': {
                            margin: '10px 0px',
                        },
                    },
                    '& .desktop-product-detail': {
                        display: 'flex',
                        'align-items': 'stretch',

                        '& .product-image': {
                            flex: 'none',
                            marginRight: `${unitBase * 2}px`,
                        },
                    },
                    '& .desktop-product-container': {
                        padding: rowSpacing * 2,
                        borderBottom: `1px dashed ${enterpriseCSS.palette.gray3}`,
                        '&:last-child': {
                            borderBottom: 'none',
                        },
                    },
                    '& .product-description': {
                        position: 'relative',

                        '& .product-name': {
                            marginBottom: rowSpacing,
                        },

                        '& .subscription': {
                            '& .subscription-delivery': {
                                display: 'block',
                            },
                        },

                        '& .product-sku': {
                            position: 'absolute',
                            bottom: 0,
                        },

                    },

                },
                '& .desktop-card-title': {
                    backgroundColor: `${enterpriseCSS.palette.gray3}`,
                },
                '& .margin-right-10': {
                    marginRight: '10px',
                },
                '& .margin-left-10': {
                    marginLeft: '10px',
                },
                '& .bottom-modify-card': {
                    minHeight: '135px',
                    borderRadius: '0px',
                    '& ul': {
                        paddingLeft: '26px',
                    },
                },
            },
            // Order Details
            '& .order-info': {
                padding: rowSpacing,
                '&:not(.gray-bg)': {
                    paddingBottom: 0,
                },
            },
            '& .delivery-info': {
                boxShadow: 'none',
                border: `2px solid ${enterpriseCSS.palette.gray1}`,

                '& hr': {
                    backgroundColor: enterpriseCSS.palette.gray3,
                    margin: `${rowSpacing}px -${rowSpacing}px`,
                },
                '& .product-detail': {
                    borderBottom: `1px dashed ${enterpriseCSS.palette.gray3}`,
                    margin: `${rowSpacing}px -${rowSpacing}px`,
                    padding: `0 ${rowSpacing}px`,
                    '&.last': {
                        borderBottom: 'none',
                        marginBottom: 0,
                    },
                    '& .product-image': {
                        width: `${unitBase * 16}px`,
                        flex: 'none',
                        marginRight: `${unitBase * 2}px`,
                    },
                    '& .product-description': {
                        '& .product-name': {
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            '-webkit-box-orient': 'vertical',
                            display: '-webkit-box',
                            '-webkit-line-clamp': 2,
                            height: 'calc(2em + 10px)',
                        },
                        '& .price-label': {
                            display: 'inline-block',
                            paddingRight: unitBase,
                            // width: `${unitBase * 10}px`,
                            textAlign: 'right',
                        },
                    },
                    // '& .product-price': {
                    //     width: `${unitBase * 25}px`,
                    //     flex: 'none',
                    // },
                },
                '& .summary-info': {
                    '& .split': {
                        marginBottom: unitBase,
                        '&:last-child': {
                            borderTop: '1px solid black',
                            fontWeight: 'bold',
                            paddingTop: unitBase,
                        },
                    },
                    '& .summary-price': {
                        width: `${unitBase * 16}px`,
                        flex: 'none',
                        textAlign: 'right',
                    },
                },
            },
            '& .card-info': {
                position: 'relative',
                boxShadow: 'none',
                border: `2px solid ${enterpriseCSS.palette.gray1}`,

                '& .card-title': {
                    backgroundColor: enterpriseCSS.palette.gray3,
                    padding: rowSpacing,
                    margin: `-${rowSpacing}px -${rowSpacing}px ${rowSpacing}px -${rowSpacing}px`,
                },

                '& ul': {
                    paddingLeft: `${rowSpacing + unitBase}px`,
                },
            },

            ...StatusTrackingBar(typography, newPalette).StatusTrackingBar,
        },
    };
};
